import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store";

type Props = {
  permission: string | (string | string[])[];
  children?: React.ReactNode;
};

const PermissionChecker: React.FC<Props> = ({ permission, children }) => {
  const appPermissions = useSelector((state: AppState) => 
    state.uiConfig.activeApplication
      ? state.uiConfig.activeApplication.permissions
      : undefined
  );

  if (permission) {
    if (!appPermissions) {
      return null;
    }
    if (typeof permission === "string") {
      if (!appPermissions[permission]) {
        return null;
      }
    } else if (Array.isArray(permission)) {
      let hasPermission = false;
      for (const perm of permission) {
        if (typeof perm === "string") {
          if (appPermissions[perm]) {
            hasPermission = true;
          }
        } else {
          let permissionResult = true;

          for (const permissionAnd of perm) {
            if (!appPermissions[permissionAnd]) {
              permissionResult = false;
            }
          }

          hasPermission = hasPermission || permissionResult;
        }
      }
      if (!hasPermission) {
        return null;
      }
    }
  }

  return <>{children}</>;
};

export default PermissionChecker;
